import { API_BASE } from './appUtils';
import { SPLASH_SEEN_KEY, CAROUSEL_SEEN_KEY } from './appConstants';

/**
 * Whether public sign-up is open (server setting REGISTRATION_OPEN). Any
 * failure counts as closed, so the sign-in page never offers a sign-up link
 * that would fail.
 */
export async function fetchRegistrationOpen(): Promise<boolean> {
  try {
    const res = await fetch(`${API_BASE}/auth/registration-status`);
    if (!res.ok) return false;
    const data = (await res.json()) as { open?: unknown };
    return data.open === true;
  } catch {
    return false;
  }
}

/**
 * Mark the splash and welcome slides as seen on this device. Called when the
 * sign-in page first shows, so someone who first arrives through a reset link
 * does not get the splash on their next visit.
 */
export function markIntroSeen(): void {
  try {
    localStorage.setItem(SPLASH_SEEN_KEY, 'true');
    localStorage.setItem(CAROUSEL_SEEN_KEY, 'true');
  } catch { /* storage may be unavailable */ }
}
